import React, { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { SelectOption } from "../FilterOperatorSelect";

interface IBooleanListProps {
  value?: string;
  onChange: (selectedValue: boolean) => void;
}

export const BooleanList = (props: IBooleanListProps): ReactElement => {
  const { t } = useTranslation();
  let selectedIndex: number;
  if (props.value != null) {
    selectedIndex = (props.value.toLowerCase() === "true") ? 0 : 1;
  }

  const booleanOptions: SelectOption[] = [ { value: '0', label: t("boolean.true") }, { value: '1', label: t("boolean.false") }];

  return (
    <Select
      options={booleanOptions}
      defaultValue={booleanOptions[selectedIndex]}
      value={booleanOptions[selectedIndex]}
      isMulti={false}
      placeholder={`${t("command.select")}...`}
      styles={{ 
        menuPortal: (base) => ({ ...base, zIndex: 9999 }), 
        control: (base) => ({...base, background: 'white', border: '1px solid #78899a', borderRadius: 0}),
        multiValue: (base) => ({...base, fontSize: "16px"}), //multiValue child has 85% font
        option: provided => ({...provided, color: 'black'}),
      }}
      onChange={(e) => {
        const selectedIdx = booleanOptions.findIndex((value: SelectOption) => value.value === e.value)
        props.onChange(selectedIdx != null && selectedIdx === 0)
      }}
    />
  );
};
